// @flow
import type { OrderCommon, OrderPersonal } from 'app/dataTypes/OrgSettingsSubsidies.types';


export const orderCommon: OrderCommon = 0;
export const orderPersonal: OrderPersonal = 1;
